export const VITAL_LIMITS = {
  systolic: { min: 40, max: 260, digits: 3, message: 'A sistólica fica entre 40 e 260 mmHg.' },
  diastolic: { min: 20, max: 180, digits: 3, message: 'A diastólica fica entre 20 e 180 mmHg.' },
  heartRate: { min: 20, max: 250, digits: 3, message: 'A frequência cardíaca fica entre 20 e 250 bpm.' },
  oxygenSaturation: { min: 50, max: 100, digits: 3, message: 'A saturação fica entre 50 e 100%.' },
  temperature: { min: 30, max: 45, decimals: 1, message: 'A temperatura fica entre 30 e 45 °C.' },
  respiratoryRate: { min: 4, max: 60, digits: 2, message: 'A frequência respiratória fica entre 4 e 60 rpm.' },
  bloodGlucose: { min: 10, max: 600, digits: 3, message: 'A glicemia fica entre 10 e 600 mg/dL.' },
  painScale: { min: 0, max: 10, digits: 2, message: 'A escala de dor fica entre 0 e 10.' }
}

export function integerTyping(raw, key) {
  const spec = VITAL_LIMITS[key]
  const digits = String(raw ?? '').replace(/\D/g, '').slice(0, spec.digits)
  if (!digits) return ''
  if (Number(digits) > spec.max) return digits.slice(0, -1)
  return digits
}

export function temperatureTyping(raw) {
  const text = String(raw ?? '').replace(',', '.')
  let formatted = ''
  if (text.includes('.')) {
    const [whole, fraction = ''] = text.split('.')
    const intPart = whole.replace(/\D/g, '').slice(0, 2)
    const dec = fraction.replace(/\D/g, '').slice(0, 1)
    if (!intPart) return ''
    formatted = dec ? `${intPart}.${dec}` : (String(raw).includes('.') || text.endsWith('.') ? `${intPart}.` : intPart)
  } else {
    const digits = text.replace(/\D/g, '').slice(0, 3)
    formatted = digits.length >= 3 ? `${digits.slice(0, 2)}.${digits.slice(2)}` : digits
  }
  if (!formatted) return ''
  const probe = formatted.endsWith('.') ? formatted.slice(0, -1) : formatted
  const value = Number(probe)
  if (!Number.isFinite(value)) return null
  if (probe.length === 1) return value === 3 || value === 4 ? formatted : null
  if (value < 30 || value > 45) return null
  return formatted
}

export function normalizeDraft(raw) {
  return String(raw ?? '').trim().replace(',', '.').replace(/\.$/, '')
}

export function measureError(key, raw) {
  const spec = VITAL_LIMITS[key]
  const text = normalizeDraft(raw)
  if (!text) return ''
  const decimals = key === 'temperature' ? 1 : 0
  if (!/^\d+(\.\d+)?$/.test(text)) return spec.message
  const fraction = text.split('.')[1] || ''
  const value = Number(text)
  if (fraction.length > decimals || value < spec.min || value > spec.max) return spec.message
  return ''
}

export function pressureError(systolic, diastolic) {
  const sys = String(systolic ?? '').trim()
  const dia = String(diastolic ?? '').trim()
  if (!sys && !dia) return ''
  if (!sys || !dia) return 'A pressão precisa da sistólica e da diastólica juntas.'
  return measureError('systolic', sys) || measureError('diastolic', dia)
    || (Number(sys) <= Number(dia) ? 'A sistólica precisa ser maior que a diastólica.' : '')
}

export function editorValue(key, value) {
  if (value == null || value === '') return ''
  const text = String(value)
  if (measureError(key, text)) return text
  return String(Number(String(text).replace(',', '.')))
}
